import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-10 md:py-14 bg-background-100/60">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2 text-center">读者评论</h2>
          <p className="text-sm text-foreground-500 mb-8 text-center">漫画读者对妖精动漫的真实评价</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {commentItems.map((item, i) => (
              <div key={i} className="bg-background-50 border border-background-200/70 rounded-xl p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-background-200">
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-full h-full object-cover"
                      width={80}
                      height={80}
                    />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{item.name}</p>
                    <p className="text-xs text-foreground-400">{item.date}</p>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}